import { useEffect, useState } from "react";
import "../../Styles/stats.scss";
import CustomPieChart from "./CustomPieChart";
import CustomBarChart from "./CustomBarChart";
import { useLayoutEffect } from "react";
import { useRef } from "react";
import html2canvas from "html2canvas";
import { BsImages, BsFiletypeCsv } from "react-icons/bs";

export default function Stats(props) {
  const [data, setData] = useState(null);
  const [monthlyStats, setMonthlyStats] = useState(null);
  const [projects, setProjects] = useState(null);
  const chrt = useRef(null);
  const [showing, setShowing] = useState(true);
  const [aspect, setAspect] = useState(1.5);
  const [aspect1, setAspect1] = useState(1.5);
  const [internal, setInternal] = useState(null);
  const [external, setExternal] = useState(null);

 const p1ref = useRef();
 const l2ref = useRef();
 const b1ref = useRef();
 const b2ref = useRef();

  useLayoutEffect(() => {
    const { width, height } = p1ref.current.getBoundingClientRect();

    setAspect(width / height);
    setAspect1(width / (height * 0.8));
  }, []);

  const handleDownloadImage = async (printRef) => {
    const element = printRef.current;
    const canvas = await html2canvas(element);

    const data = canvas.toDataURL("image/jpg");
    const link = document.createElement("a");

    if (typeof link.download === "string") {
      link.href = data;
      link.download = "image.jpg";

      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    } else {
      window.open(data);
    }
  };

  const saveData = (data) => {
    if (data.length > 0) {
      let rows = [];
      rows.push(Object.keys(data[0]));
      data.map((item) => {
        rows.push(Object.values(item));
      });
      let csvContent =
        "data:text/csv;charset=utf-8," +
        rows.map((e) => e.join(",")).join("\n");

      var encodedUri = encodeURI(csvContent);
      var link = document.createElement("a");
      link.setAttribute("href", encodedUri);
      link.setAttribute("download", "data.csv");
      document.body.appendChild(link);
      link.click();
    }
  };

  useEffect(() => {
    setShowing(false);
    setTimeout(() => {
      setShowing(true);
    }, 1);
  }, [props.showing]);

  useEffect(() => {
    fetch(`/api/documents/stats`)
      .then((res) => {
        if (res.ok) return res.json();
        else throw Error("");
      })
      .then((data) => {
        setData(data);
      })
      .catch((e) => {});
  }, []);

    useEffect(() => {
      fetch(`/api/documents/stats/Internal`)
        .then((res) => {
          if (res.ok) return res.json();
          else throw Error("");
        })
        .then((data) => {
          console.log(data);
          setInternal(data);
        })
        .catch((e) => {});
    }, []);
  
      useEffect(() => {
        fetch(`/api/documents/stats/External`)
          .then((res) => {
            if (res.ok) return res.json();
            else throw Error("");
          })
          .then((data) => {
            console.log(data);
            setExternal(data);
          })
          .catch((e) => {});
      }, []);

  useEffect(() => {
    fetch(`/api/documents/monthly/published/2023-01-01/2024-01-01`)
      .then((res) => {
        if (res.ok) return res.json();
        else throw Error("");
      })
      .then((data) => {
        
        setMonthlyStats(data);
      })
      .catch((e) => {});
  }, []);
  useEffect(() => {
    fetch(`/api/documents/charts`)
      .then((res) => {
        if (res.ok) return res.json();
        else throw Error("");
      })
      .then((data) => {
        setProjects(data);
      })
      .catch((e) => {});
  }, []);

  

  return (
    <>
      {showing && (
        <div className="stats">
          <div className="top">
            <TopItem
              title="Total Resources"
              amt={data ? data?.Resources[0].total : 0}
              color="#C9EEFF"
            />
            <TopItem
              title="Project Documents"
              amt={data ? data?.Projects[0].total : 0}
              color="#F1DEC9"
            />
            <TopItem
              title="Manuals"
              amt={data ? data?.Manuals[0].total : 0}
              color="#FBFFB1"
            />
            <TopItem
              title="Learning Materials"
              amt={data ? data?.Materials[0].total : 0}
              color="#FFA3FD"
            />
            <TopItem
              title="Reports"
              amt={data ? data?.Reports[0].total : 0}
              color="#FFA3FD"
            />
            <TopItem
              title="Publications"
              amt={data ? data?.Publications[0].total : 0}
              color="#C9EEFF"
            />
          </div>
          <div className="pies">
            <div ref={p1ref} className="chart">
              <h3>Resources Categories</h3>
              {projects && (
                <CustomPieChart data={projects?.Category} aspect={aspect} />
              )}
              <div className="save">
                <BsImages
                  color="blue"
                  onClick={() => {
                    handleDownloadImage(p1ref);
                  }}
                />
                <BsFiletypeCsv
                  color="blue"
                  onClick={() => {
                    saveData(projects?.Category);
                  }}
                />
              </div>
            </div>
            <div ref={p1ref} className="chart">
              <h3> Total Internal Documents</h3>
              {projects && <CustomPieChart data={internal} aspect={aspect} />}
              <div className="save">
                <BsImages
                  color="blue"
                  onClick={() => {
                    handleDownloadImage(p1ref);
                  }}
                />
                <BsFiletypeCsv
                  color="blue"
                  onClick={() => {
                    saveData(internal);
                  }}
                />
              </div>
            </div>
            <div ref={p1ref} className="chart">
              <h3>Total External Documents</h3>
              {projects && <CustomPieChart data={external} aspect={aspect} />}
              <div className="save">
                <BsImages
                  color="blue"
                  onClick={() => {
                    handleDownloadImage(p1ref);
                  }}
                />
                <BsFiletypeCsv
                  color="blue"
                  onClick={() => {
                    saveData(external);
                  }}
                />
              </div>
            </div>
          </div>
          <div className="middle">
            <div ref={b1ref} className="chart">
              <h3>Distribution of Resources by Type</h3>
              {projects && (
                <CustomBarChart data={projects?.Type} aspect={aspect1} />
              )}
              <div className="save">
                <BsImages
                  color="blue"
                  onClick={() => {
                    handleDownloadImage(b1ref);
                  }}
                />
                <BsFiletypeCsv
                  color="blue"
                  onClick={() => {
                    saveData(projects?.Type);
                  }}
                />
              </div>
            </div>
            <div ref={b2ref} className="chart">
              <h3>Distribution by Departments</h3>
              {projects && (
                <CustomBarChart data={projects?.Department} aspect={aspect1} />
              )}
              <div className="save">
                <BsImages
                  color="blue"
                  onClick={() => {
                    handleDownloadImage(b2ref);
                  }}
                />
                <BsFiletypeCsv
                  color="blue"
                  onClick={() => {
                    saveData(projects?.Department);
                  }}
                />
              </div>
            </div>
          </div>
          <div className="bottom">
            <div ref={l2ref} className="chart">
              <h3>Distribution of Resources by Month Published</h3>
              {console.log(monthlyStats)}
              {monthlyStats && (
                <CustomBarChart data={monthlyStats} aspect={showing? 3:2} />
              )}
              <div className="save">
                <BsImages
                  color="blue"
                  onClick={() => {
                    handleDownloadImage(l2ref);
                  }}
                />
                <BsFiletypeCsv
                  color="blue"
                  onClick={() => {
                    saveData(monthlyStats);
                  }}
                />
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
}

const TopItem = (props) => {
  function withCommas(x) {
    return x?.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
  }
  return (
    <div
      style={{ backgroundColor: props.color ?? props.color }}
      className="tp_item"
    >
      <p>{props.title}</p>
      <h1>{withCommas(props.amt)}</h1>
    </div>
  );
};
